// extracted by mini-css-extract-plugin
module.exports = {"modal":"DobModal_modal___Jxvm","close":"DobModal_close__2CblA","header":"DobModal_header__3mPpc","button":"DobModal_button__1Vf5w"};